import React from 'react';
import PropTypes from 'prop-types';
import TableReport from '@componentes/TableReport';
import IntlMessage from "../../../../../helpers/intlMessage";

function Requisicao ({ lista }) {
  const headerListItens = [
    <IntlMessage id = "dashboards.reports.requester"/>,
    <IntlMessage id = "dashboards.reports.returnDate"/>,
    <IntlMessage id = "dashboards.reports.type"/>,
    <IntlMessage id = "general.materialArchiving.identification"/>,
    <IntlMessage id = "dashboards.reports.exam"/>,
    <IntlMessage id = "general.materialArchiving.destiny"/>
  ];

  return (
    <TableReport
      title={<IntlMessage id = "dashboards.reports.reportMaterialRequest"/>}
      assinatura={<IntlMessage id = "dashboards.reports.subscriptionCRM"/>}
      headerList={headerListItens}
    >
      {lista.map((item, i) => (
        <tr key={i}>
          <td>{item.requisitante}</td>
          <td>{item.dataDevolucao}</td>
          <td>{item.tipo}</td>
          <td>{item.identificacao}</td>
          <td>{item.nrExame}</td>
          <td>{item.destino}</td>
        </tr>
      ))}
    </TableReport>
  );
}

Requisicao.propTypes = {
  lista: PropTypes.array.isRequired
};

Requisicao.defaultProps = {
  lista: []
};

export default Requisicao;



// WEBPACK FOOTER //
// ./src/pages/arquivamento/common/components/Requisicao/index.js